/* eslint-disable */
import Button from 'components/atoms/Button';
import Icon from 'components/atoms/Icon';
import Loading from 'components/atoms/Loading';
import useUploadFileService from 'hooks/useUploadFileService';
import React, { useEffect, useRef, useState } from 'react';
import { allowedImageExtensions } from 'utils/constants';

import mapModifiers, { base64ToFile, compressImageFile } from 'utils/functions';

type CameraProps = {
  isShow?: boolean;
  closeCamera?: () => void;
  conversationCode: string;
  handleChooseFile(file: UploadFileType): void;
  // handleChunkLoading?: (isLoading: boolean) => void;
};

const Camera: React.FC<CameraProps> = ({ isShow, conversationCode, closeCamera, handleChooseFile }) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const mediaStreamRef = useRef<MediaStream | null>(null);

  const [isLoading, setLoading] = useState(false);

  const onLoading = (isLoading: boolean) => {
    setLoading(isLoading);
  };

  const stopCamera = () => {
    if (mediaStreamRef.current) {
      mediaStreamRef.current.getTracks().forEach((track) => track.stop());
    }
  };

  const { uploader } = useUploadFileService({
    conversationCode,
    handleChooseFile: (file) => {
      stopCamera();
      handleChooseFile(file);
    },
    handleChunkLoading: onLoading,
    allowedExtensions: allowedImageExtensions,
  });

  const startCamera = async () => {
    try {
      // setIsShow(true);
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'environment' },
      });

      mediaStreamRef.current = stream;

      if (videoRef.current) {
        videoRef.current.srcObject = stream;

        videoRef.current.onloadedmetadata = () => {
          if (videoRef.current) {
            videoRef.current.play();
          }
        };
      }
    } catch (err) {
      console.error('Error accessing camera:', err);
    }
  };

  const capturePhoto = async () => {
    const canvas = canvasRef.current;
    const video = videoRef.current;
    if (videoRef.current) {
      videoRef.current.pause();
    }
    if (canvas && video) {
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext('2d')?.drawImage(video, 0, 0);
      const file = base64ToFile(canvas?.toDataURL('image/png'));

      try {
        const compressedFile = (await compressImageFile(file, true)) as File;
        // fileRef.current = compressedFile;
        uploader.addFiles(compressedFile);
        uploader.uploadStoredFiles();
      } catch (e) {
        console.log('Upload error for image:', file.name, e);
      }
    }
  };

  const onCloseCamera = () => {
    stopCamera();
    if (closeCamera) {
      closeCamera();
    }
  };

  useEffect(() => {
    if (isShow) {
      startCamera();
    }
  }, [isShow]);

  return (
    <>
      {isLoading && <Loading variant="fullscreen" />}
      <div className="o-scan">
        <div className={mapModifiers('o-scan_container', isShow ? 'show' : '')}>
          <div className="o-scan_header">
            <div className="o-scan_close" onClick={onCloseCamera}>
              <Icon iconName="close" size="20" />
            </div>
          </div>
          <video muted playsInline ref={videoRef} style={{ width: '100%', height: '100vh' }} />
          <canvas ref={canvasRef} style={{ display: 'none' }} />
          <div className='o-scan_footer'>
            <div className="o-scan_content">
              <div className="o-scan_btnRetry">
                <Button disabled={isLoading} onClick={capturePhoto}></Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Camera;
